import { createAction } from '@reduxjs/toolkit';
import type { AppThunk } from '../store/configureStore';

// TODO: Infer this from doc
type QRDesignResponse = {
  id: number;
  width: number;
  height: number;
  qrcode_x: number;
  qrcode_y: number;
  qrcode_size: number;
  caption_x: number;
  caption_y: number;
  caption_size: number;
  caption_color: string;
  background_image: string | null;
};

type Point = {
  x: number;
  y: number;
};

export const MOVE_TO_FIRST_PAGE = createAction<void>('QR_DESIGNER_MOVE_TO_FIRST_PAGE');
export const NEXT = createAction<void>('QR_DESIGNER_PAGE_NEXT');
export const PREVIOUS = createAction<void>('QR_DESIGNER_PAGE_PREVIOUS');
export const ENABLE_NEXT_PAGE = createAction<void>('QR_DESIGNER_ENABLE_NEXT_PAGE');
export const DISABLE_NEXT_PAGE = createAction<void>('QR_DESIGNER_DISABLE_NEXT_PAGE');
export const SET_BACKGROUND_IMAGE = createAction<string | null>('QR_DESIGNER_SET_BACKGROUND_IMAGE');
export const SET_QRCODE_POINT = createAction<Point>('QR_DESIGNER_SET_QRCODE_POINT');
export const SET_QRCODE_SIZE = createAction<number>('QR_DESIGNER_SET_QRCODE_SIZE');
export const SET_CAPTION_POINT = createAction<Point>('QR_DESIGNER_SET_CAPTION_POINT');
export const SET_CAPTION_SIZE = createAction<number>('QR_DESIGNER_SET_CAPTION_SIZE');
export const SET_CAPTION_COLOR = createAction<string>('QR_DESIGNER_SET_CAPTION_COLOR');
export const GET_QR_DESIGN = createAction<QRDesignResponse>('QR_DESIGNER_GET_QR_DESIGN');
export const GET_FAILED_QR_DESIGN = createAction<void>('QR_DESIGNER_GET_FAILED_QR_DESIGN');
export const GET_UNAUTHORIZED_QR_DESIGN = createAction<void>(
  'QR_DESIGNER_GET_UNAUTHORIZED_QR_DESIGN'
);
export const ENABLE_BOLD = createAction<void>('QR_DESIGNER_ENABLE_BOLD');
export const DISABLE_BOLD = createAction<void>('QR_DESIGNER_DISABLE_BOLD');
export const ENABLE_ITALIC = createAction<void>('QR_DESIGNER_ENABLE_ITALIC');
export const DISABLE_ITALIC = createAction<void>('QR_DESIGNER_DISABLE_ITALIC');

export const moveToFirstPage = (): AppThunk => (dispatch) => dispatch(MOVE_TO_FIRST_PAGE());

export const nextPage = (): AppThunk => (dispatch) => dispatch(NEXT());

export const previousPage = (): AppThunk => (dispatch) => dispatch(PREVIOUS());

export const enableNextPage = (): AppThunk => (dispatch) => dispatch(ENABLE_NEXT_PAGE());

export const disableNextPage = (): AppThunk => (dispatch) => dispatch(DISABLE_NEXT_PAGE());

export const setBackgroundImage =
  (image: string | null): AppThunk =>
  (dispatch) =>
    dispatch(SET_BACKGROUND_IMAGE(image));

export const setQRCodePoint =
  (x: number, y: number): AppThunk =>
  (dispatch) =>
    dispatch(SET_QRCODE_POINT({ x, y }));

export const setQRCodeSize =
  (size: number): AppThunk =>
  (dispatch) =>
    dispatch(SET_QRCODE_SIZE(size));

export const setCaptionPoint =
  (x: number, y: number): AppThunk =>
  (dispatch) =>
    dispatch(SET_CAPTION_POINT({ x, y }));

export const setCaptionSize =
  (size: number): AppThunk =>
  (dispatch) =>
    dispatch(SET_CAPTION_SIZE(size));

export const setCaptionColor =
  (color: string): AppThunk =>
  (dispatch) =>
    dispatch(SET_CAPTION_COLOR(color));

export const enableBold = (): AppThunk => (dispatch) => dispatch(ENABLE_BOLD());

export const enableItalic = (): AppThunk => (dispatch) => dispatch(ENABLE_ITALIC());

export const disableBold = (): AppThunk => (dispatch) => dispatch(DISABLE_BOLD());

export const disableItalic = (): AppThunk => (dispatch) => dispatch(DISABLE_ITALIC());

export const getQRDesign =
  (query = ''): AppThunk =>
  (dispatch) =>
    fetch(`/api/merchandise-tag?${query}`, {
      method: 'GET',
      credentials: 'same-origin',
    }).then(async (response) => {
      if (response.status === 404) {
        dispatch(setBackgroundImage(null));
        return dispatch(GET_FAILED_QR_DESIGN());
      }
      if (response.status === 403) {
        dispatch(setBackgroundImage(null));
        return dispatch(GET_UNAUTHORIZED_QR_DESIGN());
      }
      const data = await response.json();
      return dispatch(
        GET_QR_DESIGN({
          id: data.id,
          width: data.width,
          height: data.height,
          qrcode_x: data.qrcode_x,
          qrcode_y: data.qrcode_y,
          qrcode_size: data.qrcode_size,
          caption_x: data.caption_x,
          caption_y: data.caption_y,
          caption_size: data.caption_size,
          caption_color: data.caption_color,
          background_image: data.background_image || null,
        })
      );
    });
